import data from '../../../data.json'

import { useState } from 'react'
import { useSetBodyBackgrounds } from '../../../shared/bodyBackgrounds'

const Technology = () => {
    const [technology] = useState(data.technology)
    const [currentIndex, setCurrentIndex] = useState(0)

    // Call Custom Hook to set Body Backgrounds
    useSetBodyBackgrounds('tech-bg')

    const {
        name,
        images: { portrait, landscape },
        description,
    } = technology[currentIndex]

    const techLinks = technology.map((tech, index) => {
        return (
            <li key={tech.name}>
                <button
                    className={`tech__nav-link ${
                        index === currentIndex ? 'active' : ''
                    } `}
                    onClick={() => setCurrentIndex(index)}
                >
                    {index + 1}
                </button>
            </li>
        )
    })

    return (
        // <div className='container'>
        <div id='technology' className='tech container maincontent'>
            {/* <div className='container'> */}
            <h1 className='tech__main-heading '>
                <span>03</span>Space Launch 101
            </h1>
            {/* </div> */}

            <figure className='tech__img-container'>
                <img className='tech__img-portrait' src={portrait} alt={name} />
                <img
                    className='tech__img-landscape'
                    src={landscape}
                    alt={name}
                />
            </figure>
            {/* <hr /> */}

            <ul className='tech__nav-list'>{techLinks}</ul>
            <section className='tech__info'>
                <section className='tech__info-heading'>
                    <h3 className='tech__subheading'>The Terminology...</h3>
                    <h2 className='tech__name'>{name}</h2>
                </section>
                <p className='tech__description'>{description}</p>
            </section>
        </div>
        // </div>
    )
}

export default Technology
